(function () {
  var idInput = document.querySelector("[data-variant-id]");
  var priceEl = document.querySelector("[data-price]");
  var radios = document.querySelectorAll(".p2-buy__variant input");

  function selectVariant(radio) {
    radio.checked = true;
    if (idInput) idInput.value = radio.value;
    if (priceEl) priceEl.textContent = radio.getAttribute("data-vprice");
    document.querySelectorAll(".p2-buy__variant").forEach(function (label) {
      label.classList.toggle("is-active", label.contains(radio));
    });
  }

  radios.forEach(function (radio) {
    radio.addEventListener("change", function () {
      selectVariant(radio);
    });
  });

  document.querySelectorAll("[data-select-variant]").forEach(function (link) {
    link.addEventListener("click", function () {
      radios.forEach(function (radio) {
        if (radio.value === link.getAttribute("data-select-variant")) selectVariant(radio);
      });
    });
  });

  document.querySelectorAll("[data-acc-group]").forEach(function (group) {
    var items = group.querySelectorAll("details");
    items.forEach(function (d) {
      d.addEventListener("toggle", function () {
        if (!d.open) return;
        items.forEach(function (other) {
          if (other !== d) other.open = false;
        });
      });
    });
  });
})();

/* Mobile gallery: builds a thumbnail strip from the gallery shots and keeps it
   in sync with the swipeable main image (carousel is CSS scroll-snap; active
   only under the pdp2.css max-width:1040px rules — on desktop the strip is
   display:none and the gallery keeps its stacked grid). */
(function () {
  var gallery = document.querySelector(".p2-buy__gallery");
  if (!gallery) return;
  var slides = Array.prototype.slice.call(gallery.children);
  if (slides.length < 2) return;

  var thumbsBar = document.createElement("div");
  thumbsBar.className = "p2-buy__thumbs";
  thumbsBar.setAttribute("aria-label", "Product images");

  var thumbs = slides.map(function (slide, i) {
    var img = slide.querySelector("img");
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "p2-buy__thumb" + (i === 0 ? " is-active" : "");
    btn.setAttribute("aria-label", "View image " + (i + 1) + " of " + slides.length);
    if (img) {
      var t = document.createElement("img");
      t.src = (img.currentSrc || img.src).replace(/([?&]width=)\d+/, "$1180");
      t.alt = "";
      t.loading = "lazy";
      btn.appendChild(t);
    }
    btn.addEventListener("click", function () {
      goTo(i);
    });
    return btn;
  });
  thumbs.forEach(function (btn) {
    thumbsBar.appendChild(btn);
  });
  gallery.insertAdjacentElement("afterend", thumbsBar);

  function setActive(i) {
    thumbs.forEach(function (btn, j) {
      btn.classList.toggle("is-active", j === i);
    });
    var btn = thumbs[i];
    var left = btn.offsetLeft - (thumbsBar.clientWidth - btn.clientWidth) / 2;
    try {
      thumbsBar.scrollTo({ left: left, behavior: "smooth" });
    } catch (e) {
      thumbsBar.scrollLeft = left;
    }
  }

  function goTo(i) {
    setActive(i);
    var left = i * gallery.clientWidth;
    try {
      gallery.scrollTo({ left: left, behavior: "smooth" });
    } catch (e) {
      gallery.scrollLeft = left;
    }
  }

  var ticking = false;
  gallery.addEventListener(
    "scroll",
    function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        if (!gallery.clientWidth) return;
        var i = Math.round(gallery.scrollLeft / gallery.clientWidth);
        i = Math.max(0, Math.min(slides.length - 1, i));
        if (!thumbs[i].classList.contains("is-active")) setActive(i);
      });
    },
    { passive: true }
  );
})();
